import { ComponentType, lazy } from "react";
import widgetRegistry, { WidgetType } from "../widgets/widgetRegistry";
import FallbackWidget from "../widgets/FallbackWidget";

// Load a widget with fallback
export const loadWidget = (type: WidgetType): React.LazyExoticComponent<ComponentType<any>> => {
  const registryLoader = widgetRegistry[type];
  if (!registryLoader) {
    return lazy(async () => ({ default: FallbackWidget }));
  }
  return registryLoader;
};
